import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=04b88d9c&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&id=04b88d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b88d9c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/home/northbankcm/public_html/frontend/components/modules/Video.vue').default})
